<template>
  <div>
    <v-autocomplete
      :label="title"
      v-model="producto.proveedor"
      :items="proveedores"
      item-text="nombre"
      item-value="id"
      return-object
      :clearable="clearable"
      :disabled="disabled"
      :placeholder="placeholder"
      :filled="filled"
      :solo="solo"
      :flat="flat"
      :dense="dense"
      :outlined="outlined"
      @change="set_select_data"
      @click:clear="clearData"
      @update:search-input="onSearchInput"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>No hay proveedores</v-list-item-title>
        </v-list-item>
      </template>

      <template v-slot:prepend-item>
        <v-list-item v-if="loading">
          <v-list-item-content class="text-center">
            <v-progress-circular indeterminate />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "ProveedorAutoCompleteFirstPage",

  props: {
    producto: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    title: { type: String, default: "Proveedor" },
    solo: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    dense: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    pageSize: { type: Number, default: 15 },
  },

  data() {
    return {
      proveedores: [],
      search: "",
      loading: false,
      debounceTimer: null,
    };
  },

  methods: {
    set_select_data(data) {
      this.$emit("set_proveedor", data);
    },

    clearData() {
      this.$emit("set_proveedor", null);
    },

    onSearchInput(val) {
      this.search = val;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.fetchFirstPage();
      }, 300);
    },

    async fetchFirstPage() {
      this.loading = true;

      try {
        const params = new URLSearchParams();
        params.append("page", 1);
        params.append("page_size", this.pageSize);
        if (this.search) params.append("search", this.search);

        const res = await this.axios.get(`/proveedores/?${params.toString()}`);
        this.proveedores = Array.isArray(res.data.results)
          ? res.data.results
          : [];

        this.ensureProveedorFromProducto();

      } catch (e) {
        console.error("Error cargando proveedores:", e);
        this.proveedores = [];
      } finally {
        this.loading = false;
      }
    },

    ensureProveedorFromProducto() {
      const sel = this.producto.proveedor;
      if (!sel || !sel.id) return;

      const exists = this.proveedores.some((p) => p.id === sel.id);
      if (!exists) {
        this.proveedores.unshift(sel);
      }
    },
  },

  async created() {
    // Carga inicial
    await this.fetchFirstPage();
  },
};
</script>

<style scoped></style>
